export default "__VITE_ASSET__BDyQl$$W__"